module.exports = __webpack_public_path__ + "static/media/clock.829f7956.svg";